<h1 class="h3 pb-2 mb-2 border-bottom">App domains</h1>
<router-outlet></router-outlet>
